export const EMISSIONS_BREAKDOWN_SCOPE_BY_CARD = Object.freeze({
  total: "all",
  scope1: 1,
  scope2: 2,
  scope3: 3,
});

export const EMISSIONS_BREAKDOWN_TITLE_BY_SCOPE = Object.freeze({
  all: "Total Emissions breakdown",
  1: "Scope 1 Emissions breakdown",
  2: "Scope 2 Emissions breakdown",
  3: "Scope 3 Emissions breakdown",
});

export const EMISSIONS_BREAKDOWN_METRIC_TITLE_BY_SCOPE = Object.freeze({
  all: "Total Emissions",
  1: "Scope 1 Emissions",
  2: "Scope 2 Emissions",
  3: "Scope 3 Emissions",
});

export const getEmissionsBreakdownTitle = (scope) =>
  EMISSIONS_BREAKDOWN_TITLE_BY_SCOPE[String(scope)] ||
  EMISSIONS_BREAKDOWN_TITLE_BY_SCOPE.all;

export const getEmissionsBreakdownMetricTitle = (scope) =>
  EMISSIONS_BREAKDOWN_METRIC_TITLE_BY_SCOPE[String(scope)] ||
  EMISSIONS_BREAKDOWN_METRIC_TITLE_BY_SCOPE.all;
